module.exports = __webpack_public_path__ + "static/img/icon-MEL.dbaa057.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-MEL.svg
// module id = FCo0
// module chunks = 0